import styled from "styled-components/macro";
import { darkBlue } from "../../../../constants/colors";

export const ChartStyles = styled.div`
  page-break-before: always !important;
  display: flex;
  flex-direction: column;
  align-content: center;
  justify-content: center;
  .chartTitle {
    text-align: center;
    font-size: 1.4em;
    color: ${darkBlue};
    margin-top: 14px;
    margin-bottom: 7px;
  }

  .recharts-legend-wrapper {
    width: 100% !important;
  }

  .chartBody {
    box-sizing: border-box;
  }
`;
